import React from 'react';
import Map from './Map'
import Sidebar from './Sidebar';

const distFrom = require('distance-from');

const Container: React.FunctionComponent<any> = (data) => {
  const [initialized, setInitialized] = React.useState(false);
  const [points, setPoints] = React.useState([]);
  const [newsItems, setNewsItems] = React.useState([]);
  const [sideBarPoints, setSideBarPoints] = React.useState([]);
  const [selectedPoint, setSelectedPoint] = React.useState(null);
  const [addressSearchResults, setAddressSearchResults] = React.useState<any>(null);
  const [searchMarkerLatLong, setSearchMarkerLatLong] = React.useState<any>(null);


  const searchZoom = 12;
  const focusZoom = 15;
  const initalZoom = 4;
  const initialLocation = [38.967243, -99.771556];
  const distanceThresholdMiles = 20;

  React.useEffect(() => {
    setPoints(data?.data?.value?.organizations);
    setNewsItems(data?.data?.value?.histories);

    if (points && !initialized) {
      setInitialized(true);
    }
    // eslint-disable-next-line
  }, [data, initialized]);

  React.useEffect(() => {
    setSideBarPoints(points);
    // eslint-disable-next-line
  }, [points]);

  const handleSelection = (organization: any) => setSelectedPoint(organization);
  const removeSelection = () => {
    setSelectedPoint(null);
    setSideBarPoints(points);
  };

  const isStateSearch = (results: any) => {
    return results[0].accuracy_type === 'state' && results.length > 0;
  };

  const onSearch = (searchTerm: string) => {
    const requestUrl = 'https://api.geocod.io/v1.6/geocode?q=' + searchTerm + '&api_key=11ea6f425abb2e4ae10642b62666252050f564f&limit=1';

    if (searchTerm) {
      fetch(requestUrl)
        .then(res => res.json())
        .then(
          (result) => {
            if (!result.error) {
              let address; 
              removeSelection();
              if (isStateSearch(result.results)) {
                setAddressSearchResults(result.results);
                address = result.results[0];
                setSearchMarkerLatLong({lat: address.location.lat, lng: address.location.lng, isStateSearch: true, address});
                findCloseToSearchMarker({lat: address.location.lat, lng: address.location.lng, isStateSearch: true, address}, result.results);
             
              } else if ((!result.results[0].address_components.zip  || result.results.length === 0)) {
                alert('Could not find the address you\'ve entered.');
              } else {
                setAddressSearchResults(result.results);
                address = result.results[0];
                setSearchMarkerLatLong({lat: address.location.lat, lng: address.location.lng, isStateSearch: false, address});
                findCloseToSearchMarker({lat: address.location.lat, lng: address.location.lng, isStateSearch: false, address}, result.results);
             
              }
            } else {
              setSearchMarkerLatLong(null);
              setSideBarPoints(points);
              alert(result.error);
            }
          },
          (error) => {
            console.log(error)
            setSearchMarkerLatLong(null);
            setSideBarPoints(points);
          }
        )
    } else {
      setSearchMarkerLatLong(null);
      setSideBarPoints(points);
    }
  };

  const onMarkerSelect = (markerId: number) => {
    const point = points.find((point:any) => point.id === markerId) || null;
    setSelectedPoint(point);
  };

  const findCloseToSearchMarker = (searchMarker: any, addressResults: any) => {
    if (addressResults?.length > 0) {
      setSideBarPoints(points.filter((point: any) => {
        if (searchMarker.isStateSearch) {
          if (searchMarker.address.address_components.state == point.state.short_name) {
            return point;
          }
        } else {
          const distance = distFrom([searchMarker.lat, searchMarker.lng]).to([point.latitude, point.longitude]).in('mi');
          if(distance <= distanceThresholdMiles) {
            return point;
          }
        }
      }));
    }
  }

  return (
    <div className="flex flex-col-reverse md:flex-row text-white bg-maf-black">
      <Sidebar onClick={handleSelection} searchMarkerLatLong={searchMarkerLatLong} removePoint={removeSelection} onSearch={onSearch} selectedPoint={selectedPoint} points={sideBarPoints} news={newsItems} />
      <Map onClick={handleSelection} searchMarkerLatLong={searchMarkerLatLong} onMarkerSelect={onMarkerSelect} selectedPoint={selectedPoint} points={points} />
    </div>
  )
}

export default Container;
